import request from '@/utils/request'

let Qkd_typeApi = {

  /*取快递类型列表*/
  list(data) {
    return request._post('/shop/plus.qkd_type.Index/index', data);
},
/*添加取快递类型*/
add(data) {
    return request._post('/shop/plus.qkd_type.Index/add', data);
},
/*修改取快递类型*/
edit(data) {
    return request._post('/shop/plus.qkd_type.Index/edit', data);
},
/*删除取快递类型*/
del(data) {
    return request._post('/shop/plus.qkd_type.Index/del', data);
},
/*取快递类型详情*/
detail(data) {
  return request._post('/shop/plus.qkd_type.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.qkd_type.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.qkd_type.Setting/getSetting', data, errorback);
    },
}
export default Qkd_typeApi;



// WEBPACK FOOTER //
// ./src/api/qkd_type.js